const GalleryIcon = ({ size = 24, ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M3 12C3 7.75736 3 5.63604 4.31802 4.31802C5.63604 3 7.75736 3 12 3C16.2426 3 18.364 3 19.6819 4.31802C21 5.63604 21 7.75736 21 12C21 16.2426 21 18.364 19.6819 19.6819C18.364 21 16.2426 21 12 21C7.75736 21 5.63604 21 4.31802 19.6819C3 18.364 3 16.2426 3 12Z"
                stroke="#0069AD"
            />
            <path
                d="M15.6 10.2001C16.5942 10.2001 17.4 9.39421 17.4 8.4001C17.4 7.40599 16.5942 6.6001 15.6 6.6001C14.6059 6.6001 13.8 7.40599 13.8 8.4001C13.8 9.39421 14.6059 10.2001 15.6 10.2001Z"
                fill="#BBD8ED"
                stroke="#00A7E4"
            />
            <path
                d="M3 12.4501L4.57643 11.0707C5.39657 10.3532 6.63265 10.3943 7.40324 11.1649L11.264 15.0256C11.8825 15.6442 12.8561 15.7285 13.5718 15.2255L13.8401 15.0369C14.8699 14.3132 16.2632 14.397 17.1989 15.2391L20.1 17.8501"
                stroke="#0069AD"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default GalleryIcon;